import type { ICellRendererParams } from 'ag-grid-community';
import type { ForecastRun } from '../../schema';

// One small monospace chip per horizon — visual signal of which targets
// the run produced. Always sorted ascending for stable reading.
export function HorizonsChips(
  p: ICellRendererParams<ForecastRun, number[]>,
) {
  const horizons = p.value;
  if (!horizons || horizons.length === 0) {
    return <span className="text-border-strong">—</span>;
  }
  const sorted = [...horizons].sort((a, b) => a - b);
  return (
    <div className="flex h-full flex-wrap items-center gap-1">
      {sorted.map((h) => (
        <span
          key={h}
          className="inline-flex items-center rounded-md bg-surface-muted px-1.5 py-0.5 font-mono text-[11px] font-medium text-foreground ring-1 ring-border"
        >
          {h}d
        </span>
      ))}
    </div>
  );
}
